<div class="facial-recognition-image-uploader">
  <div class="position-relative">
    <fgb-facial-recognition-uploader-header
      facialRecognitionHeading="{{ facialRecognitionHeading | translate }}"
      facialRecognitionSubheading="{{ facialRecognitionSubheading | translate }}"
      [showBackButton]="false"
    ></fgb-facial-recognition-uploader-header>
    <div class="position-absolute top-0 end-0 cursor-pointer" (click)="close()">
      <span class="icon material-icons font-size-20 p-2">close</span>
    </div>
  </div>

  <div *ngIf="!barcode" class="d-flex flex-lg-row flex-column gap-3 px-3 py-4">
    <fgb-facial-recognition-uploader-button
      class="image-upload-options"
      [facialRecognitionButtonType]="1"
      (takePhoto)="takePhoto()"
    ></fgb-facial-recognition-uploader-button>
    <div
      class="d-lg-flex d-none flex-lg-column align-items-center justify-content-center image-upload-options rounded border cursor-pointer"
      (click)="getImageDataByLink()"
    >
      <span class="icon material-icons mb-1">qr_code</span>
      <label>Generate QR Code</label>
    </div>
    <fgb-facial-recognition-uploader-button
      class="image-upload-options"
      [uploadedImage]="uploadedImage"
      [formData]="formData"
      [facialRecognitionButtonType]="2"
      (uploadedImageEvent)="uploadedImageChange()"
    ></fgb-facial-recognition-uploader-button>
  </div>
</div>

<ng-container *ngIf="barcode">
  <div class="qr-modal d-lg-block d-none mb-5">
    <div class="qr mx-auto mt-3">
      <qrcode [qrdata]="barcode" [width]="212" [errorCorrectionLevel]="'M'" [elementType]="'svg'"></qrcode>
    </div>
    <div class="container facial-recognition-details-div mt-4">
      <ul
        class="facial-recognition-info font-size-14 px-2"
        [innerHtml]="'facial.recognition.barcode.info' | translate | markdownTranslate"
      ></ul>
    </div>
  </div>
</ng-container>
